// useMenuStyles.ts
import { alpha } from '@mui/material';
const baseMenuItemSx = (theme, variant = 'dark') => ({
    color: variant === 'light' ? theme.palette.text.primary : theme.palette.common.white,
    minWidth: '200px',
    width: 'auto',
    '&:hover': {
        borderRadius: 0,
        overflow: 'hidden',
        bgcolor: alpha(theme.palette.action.selected, variant === 'light' ? 0.08 : 0.25)
    },
    '&.Mui-selected': {
        borderRadius: 0,
        overflow: 'hidden',
        bgcolor: alpha(theme.palette.action.selected, variant === 'light' ? 0.12 : 0.16)
    }
});
export const GroupedMenuItem = (theme, isFirstInGroup = false, variant = 'dark') => ({
    ...baseMenuItemSx(theme, variant)
});
export const UngroupedMenuItem = (theme, variant = 'dark') => ({
    ...baseMenuItemSx(theme, variant)
});
const useMenuStyles = (variant = 'dark') => {
    return {
        mainMenuTag: {
            bgcolor: variant === 'light' ? '#FFFFFFEB' : '#212B36E5',
            backdropFilter: 'blur(40px)',
            mt: 1,
            width: 'fit-content',
            minWidth: 220,
            maxHeight: 360,
            border: 'none',
            boxShadow: '-20px 20px 40px -4px #919EAB3D, 0px 0px 2px 0px #919EAB3D',
            borderRadius: (theme) => theme.spacing(1.5)
        },
        menuText: {
            fontWeight: 400,
            fontSize: '14px',
            color: (theme) => (variant === 'light' ? theme.palette.text.primary : theme.palette.common.white)
        },
        menuIcon: {
            minWidth: 32,
            color: (theme) => (variant === 'light' ? theme.palette.text.primary : theme.palette.common.white)
        }
    };
};
export default useMenuStyles;
